export default __webpack_public_path__ + "e2991a9c91b07cb47698f202ab5d0753.png";